/* ──────────────────────────────────────────────────────────────────────────
 * Oracle {IPO.GPT} knowledge-hub banner — shared, self-contained module.
 *
 * Rendered in multiple surfaces (Join-as-Investor flow, IPO Navigator dashboard…).
 * It carries its own concrete-colour CSS (OracleHubBanner.css) so it looks
 * identical regardless of the parent design-system root. Typing a question or
 * clicking a quick chip routes to /oracle?q=<query>, where the Oracle page
 * auto-submits it — so every query (and the user's full history) is stored in
 * the same place (oracle_threads / oracle_messages, per user).
 * ────────────────────────────────────────────────────────────────────────── */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./OracleHubBanner.css";

const CHIPS = [
  { label: "Main Board vs SME?", q: "Main Board vs SME — which IPO route is right for my company?" },
  { label: "The IPO process", q: "Walk me through the full IPO process in India, step by step." },
  { label: "How am I valued?", q: "How is my company valued for an IPO in India?" },
  { label: "Cost & timeline", q: "What does an IPO cost and how long does it take in India?" },
];

const OracleHubBanner = ({ className = "" }) => {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const go = (text) => {
    const query = (typeof text === "string" ? text : q).trim();
    if (!query) return;
    navigate(`/oracle?q=${encodeURIComponent(query)}`);
  };
  return (
    <div className={`ohb ${className}`} data-testid="oracle-hub-banner">
      <div className="ohb-head">
        <div className="ohb-logo"><i className="ti ti-sparkles" aria-hidden="true" /></div>
        <div className="ohb-brand">
          <div className="ohb-brand-t">Oracle <span>{"{IPO.GPT}"}</span></div>
          <div className="ohb-brand-s">Knowledge hub · powered by IPOLabs</div>
        </div>
        <span className="ohb-beta">Beta · your IPO tutor</span>
      </div>
      <div className="ohb-body">
        <div className="ohb-eyebrow">New to IPOs? Start here</div>
        <div className="ohb-h">Understand the entire IPO journey – in plain language.</div>
        <div className="ohb-sub">Ask Oracle anything about going public, raising capital or the markets. No jargon, no assumptions — built for first-time founders and promoters.</div>
        <div className="ohb-bar">
          <input
            className="ohb-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") go(); }}
            placeholder="Ask Oracle… e.g. What is a DRHP and why do I need one?"
            data-testid="oracle-hub-input"
          />
          <button className="ohb-ask" onClick={() => go()} data-testid="oracle-hub-ask">
            <i className="ti ti-send" aria-hidden="true" /> Ask
          </button>
        </div>
        <div className="ohb-chips">
          {CHIPS.map((c, i) => (
            <button key={i} className="ohb-chip" onClick={() => go(c.q)} data-testid={`oracle-hub-chip-${i}`}>{c.label}</button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OracleHubBanner;
